import { trans } from '@spotahome/soyuz/client';

import { getMonths } from './DateRangeHandler';
import { formatPricingDate } from './dateUtils';

const TRANS_PREFIX = 'booking_request.spotahome_booking_payment_info';
const WEEKS = 'weekly';

const getAllPendingPayments = pricing =>
  pricing.tenantPayments.filter(price => price !== 0 && price !== '0');

const areAllMonthsIncludedInFirstPayment = pricing =>
  getAllPendingPayments(pricing).length === 0;

const getMonthFirstPayment = pricing => {
  const months = getMonths(pricing.checkIn, pricing.checkOut);
  const index = pricing.tenantPayments.findIndex(
    price => price === 0 || price === '0'
  );
  return months[index];
};

export const getDownPaymentText = (pricing, downPaymentTimeInterval) => {
  const { type: downPaymentType, value: downPaymentValue } =
    downPaymentTimeInterval;

  if (downPaymentType === WEEKS) {
    return trans(`${TRANS_PREFIX}.summary.week_advance`, {
      weeks: downPaymentValue
    });
  }
  if (getAllPendingPayments(pricing).length === 0) {
    return trans(`${TRANS_PREFIX}.summary.whole_rent`);
  }
  return `${trans(`${TRANS_PREFIX}.summary.month_rent`, {
    month: trans(`label.month.${getMonthFirstPayment(pricing)}`)
  })}`;
};

export const getDownPaymentForFirstMonthStrategy = ({
  landlordContractType = 'daily',
  tenantPaymentsWithCoverage
}) => {
  const { downPaymentDays, downPaymentFrom, downPaymentTo } =
    tenantPaymentsWithCoverage;

  const downPaymentTooltipDurationInfo = trans(
    `spotahomeBookingPaymentInfo.downPaymentFirstMonthStrategy.tooltip.duration`,
    {
      days: downPaymentDays
    }
  );

  const downPaymentTooltipContractTypeInfo = trans(
    `spotahomeBookingPaymentInfo.downPaymentFirstMonthStrategy.tooltip.contractType.${landlordContractType.toLowerCase()}`,
    {
      days: downPaymentDays
    }
  );

  return {
    name: trans(
      `spotahomeBookingPaymentInfo.downPaymentFirstMonthStrategy.title`,
      {
        days: downPaymentDays
      }
    ),
    hint: trans(
      'spotahomeBookingPaymentInfo.downPaymentFirstMonthStrategy.hint',
      {
        from: formatPricingDate(downPaymentFrom),
        to: formatPricingDate(downPaymentTo)
      }
    ),
    tooltip: `${downPaymentTooltipDurationInfo}\n\n${downPaymentTooltipContractTypeInfo}`
  };
};

export const getPaymentsForFirstMonthStrategy = (monthlyPayments, pricing) => {
  const { payments } = pricing.tenantPaymentsWithCoverage;
  return monthlyPayments.map((monthlyPayment, i) => {
    if (i === 0) {
      return {
        ...monthlyPayment,
        priceLabel: trans(
          'spotahomeBookingPaymentInfo.downPaymentFirstMonthStrategy.firstMonthCovered'
        ),
        alreadyPaid: false,
        tooltip: trans(
          'spotahomeBookingPaymentInfo.downPaymentFirstMonthStrategy.tooltip.fullMonth'
        )
      };
    }

    return {
      ...monthlyPayment,
      hint:
        payments[i] && payments[i].days
          ? trans(
              'spotahomeBookingPaymentInfo.downPaymentFirstMonthStrategy.hint',
              {
                from: formatPricingDate(payments[i].from),
                to: formatPricingDate(payments[i].to)
              }
            )
          : null,
      tooltip:
        i === 1 && payments[i] && payments[i].days
          ? trans(
              'spotahomeBookingPaymentInfo.downPaymentFirstMonthStrategy.tooltip.partialMonth'
            )
          : null
    };
  });
};

export const getClarificationText = pricing => {
  if (areAllMonthsIncludedInFirstPayment(pricing)) {
    return trans(`${TRANS_PREFIX}.footer.whole_rent_clarification`);
  }

  return trans(`${TRANS_PREFIX}.footer.month_rent_clarification`, {
    month: trans(`label.month.${getMonthFirstPayment(pricing)}`)
  });
};

export default {
  getDownPaymentText,
  getClarificationText
};
